import { useState } from "react";
import { API_CALLS } from "../../../../../API/api_calls";
import { ArticleProps } from "../../../../../redux/slices/article/Article";
import Upload from "../../upload";
import { useFindContent } from "../../useFindContent";
import { ContentProps } from "../Content";
import { MaxWidthContainer } from "../style";
import AudioPreview from "./AudioPreview";
import AudioCreate from "./audioCreate";
import { API_STATUS } from "../../../../../redux/common";

const Audio = ({ id }: ContentProps.CommonProps) => {
  const { content_data, content_id, post_id } = useFindContent(
    id
  ) as ArticleProps.WithAudioContent;
  const { audio_path, title, description, image_id } = content_data;
  const [isAudioCreated, setIsAudioCreated] = useState(
    audio_path && title && description ? true : false
  );
  const [uploadAudioAPI_STATUS, setUploadAudioAPI_STATUS] =
    useState<API_STATUS>("idle");

  const onDeleteAudio = () => {
    API_CALLS.ARTICLE.deleteASingleArticleContent(id);
    if (audio_path) {
      API_CALLS.ARTICLE.deleteArticleAudio({ post_id, content_id });
      image_id &&
        API_CALLS.ARTICLE.deleteArticleAudioImage({
          content_id,
          post_id,
        });
    }
  };

  return audio_path ? (
    <MaxWidthContainer>
      {isAudioCreated ? (
        <AudioPreview
          id={id}
          setIsAudioCreated={setIsAudioCreated}
          onDeleteAudio={onDeleteAudio}
        />
      ) : (
        <AudioCreate
          id={id}
          setIsAudioCreated={setIsAudioCreated}
          onDeleteAudio={onDeleteAudio}
        />
      )}
    </MaxWidthContainer>
  ) : (
    <Upload
      iconType="AudioNew"
      onClose={onDeleteAudio}
      title="Add an audio"
      fileType="audio"
      isUploading={uploadAudioAPI_STATUS === "progress"}
      onUpload={(e) => {
        const files = e.target.files;
        if (files?.length) {
          API_CALLS.ARTICLE.uploadAudioForArticleDraft(
            {
              content_id,
              post_id,
              audio: files[0],
            },
            setUploadAudioAPI_STATUS
          );
        }
      }}
      onDrop={(e) => {
        e.preventDefault();
        const files = e.dataTransfer.files;
        if (!files.length) return;
        if (files[0].type.includes("audio")) {
          API_CALLS.ARTICLE.uploadAudioForArticleDraft(
            {
              content_id,
              post_id,
              audio: files[0],
            },
            setUploadAudioAPI_STATUS
          );
        }
      }}
    />
  );
};

export default Audio;
